﻿import { request_payment } from "./request_payment";
import { request_payment_token } from "./request_payment_token";
import { request_payment_url } from "./request_payment_url";


export enum payment_profile
{
    Default = 0,
    Cards = 1,
    Wallets = 2,
    BankTransfers = 3,
}
    
export class request {
    public booking_id: number | null = null;
    public iso_currency_code: string | null = null;
    public full_payment: boolean | null = null;
    public deposit: boolean | null = null;
    public online_sale: boolean | null = null;
    public nett_sale: boolean = false;
    public amount: number | null = null;
    public token: request_payment_token = new request_payment_token();
    public payments: request_payment[] = [];
    public payment_urls: request_payment_url = new request_payment_url();
    public payment_provider: string | null = null;
    public payment_methods: string[] = [];
    public payment_profile: payment_profile = payment_profile.Default;

     toJSON() {
        const payment_profile_ToNumber: Record<payment_profile, number> = {
        [payment_profile.Default]: 0,
        [payment_profile.Cards]: 1,
        [payment_profile.Wallets]: 2,
        [payment_profile.BankTransfers]: 3,
        };

        return {
            booking_id: this.booking_id,
            iso_currency_code: this.iso_currency_code,
            full_payment: this.full_payment,
            deposit: this.deposit,
            online_sale: this.online_sale,
            nett_sale: this.nett_sale,
            amount: this.amount,
            token: this.token,
            payments: this.payments,
            payment_urls: this.payment_urls,
            payment_provider: this.payment_provider,
            payment_methods: this.payment_methods,
            payment_profile: payment_profile_ToNumber[this.payment_profile]
        };
    }
}